import { defaultStatus } from "../defaultState/defaultState";
import {
  ADD_DEPARTMENT_FAILURE,
  ADD_DEPARTMENT_REQUEST,
  ADD_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAILURE,
  DELETE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_SUCCESS,
  FETCH_DEPARTMENT_FAILURE,
  FETCH_DEPARTMENT_REQUEST,
  FETCH_DEPARTMENT_SUCCESS,
  FETCH_LIST_DEPARTMENT_FAILURE,
  FETCH_LIST_DEPARTMENT_REQUEST,
  FETCH_LIST_DEPARTMENT_SUCCESS,
  RESET_CURRENT_DEPARTMENT,
  UPDATE_DEPARTMENT_FAILURE,
  UPDATE_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_SUCCESS,
  FETCH_COMMON_DEPARTMENT_REQUEST,
  FETCH_COMMON_DEPARTMENT_SUCCESS,
  FETCH_COMMON_DEPARTMENT_FAILURE,
} from "./departmentType";

const initialState = {
  departments: [],
  currentDepartment: null,
  fetchDepartments: { ...defaultStatus },
  fetchDepartment: { ...defaultStatus },
  addDepartment: { ...defaultStatus },
  updateDepartment: { ...defaultStatus },
  deleteDepartment: { ...defaultStatus },
  fetchCommonDepartments: { ...defaultStatus },
  commonDepartments: [],
  formMode: null, 
};

const departmentReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case FETCH_LIST_DEPARTMENT_REQUEST:
      return {
        ...state,
        fetchDepartments: { ...state.fetchDepartments, inProgress: true },
      };
    case FETCH_LIST_DEPARTMENT_SUCCESS:
      return {
        ...state,
        fetchDepartments: {
          ...state.fetchDepartments,
          success: true,
          inProgress: false,
          departments: payload?.departments,
        },

      };
    case FETCH_LIST_DEPARTMENT_FAILURE:
      return {
        ...state,
        fetchDepartments: {
          ...state.fetchDepartments,
          error: true,
          errorMessage: payload.error,
        },
      };


    case FETCH_DEPARTMENT_REQUEST:
      return {
        ...state,
        fetchDepartment: { ...state.fetchDepartment, inProgress: true },
      };
    case FETCH_DEPARTMENT_SUCCESS:
      return {
        ...state,
        fetchDepartment: {
          ...state.fetchDepartment,
          success: true,
          inProgress: false,
        },
        currentDepartment: payload.department,
      };
    case FETCH_DEPARTMENT_FAILURE:
      return {
        ...state,
        fetchDepartment: {
          ...state.fetchDepartment,
          error: true,
          errorMessage: payload.error,
        },
      };


    case ADD_DEPARTMENT_REQUEST:
      return {
        ...state,
        addDepartment: { ...state.addDepartment, inProgress: true },
      };
    case ADD_DEPARTMENT_SUCCESS:
      return {
        ...state,
        addDepartment: {
          ...state.addDepartment,
          success: true,
          inProgress: false,
        },
        departments: [...state.departments, payload.department],
        currentDepartment: payload.department,
      };
    case ADD_DEPARTMENT_FAILURE:
      return {
        ...state,
        addDepartment: {
          ...state.addDepartment,
          error: true,
          errorMessage: payload.error,
        },
      };

    case UPDATE_DEPARTMENT_REQUEST:
      return {
        ...state,
        updateDepartment: { ...state.updateDepartment, inProgress: true },
      };
    case UPDATE_DEPARTMENT_SUCCESS: {
      const updatedDepartment = payload.department;
      return {
        ...state,
        updateDepartment: {
          ...state.updateDepartment,
          success: true,
          inProgress: false,
        },
        departments: state.departments.map((department) =>
          department.id === updatedDepartment.id
            ? updatedDepartment
            : department
        ),
        currentDepartment: updatedDepartment,
      };
    }
    case UPDATE_DEPARTMENT_FAILURE:
      return {
        ...state,
        updateDepartment: {
          ...state.updateDepartment,
          error: true,
          errorMessage: payload.error,
        },
      };

    case DELETE_DEPARTMENT_REQUEST:
      return {
        ...state,
        deleteDepartment: { ...state.deleteDepartment, inProgress: true },
      };
    case DELETE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        deleteDepartment: {
          ...state.deleteDepartment,
          success: true,
          inProgress: false,
        },
        departments: state.departments.filter(
          (department) => department.id !== payload.departmentId
        ),
        currentDepartment:
          state.currentDepartment?.id === payload.departmentId
            ? null
            : state.currentDepartment,
      };
    case DELETE_DEPARTMENT_FAILURE:
      return {
        ...state,
        deleteDepartment: {
          ...state.deleteDepartment,
          error: true,
          errorMessage: payload.error,
        },
      };

    case RESET_CURRENT_DEPARTMENT:
      return {
        ...state,
        currentDepartment: null,
      };

    case FETCH_COMMON_DEPARTMENT_REQUEST:
      return {
        ...state,
        fetchCommonDepartments: { ...state.fetchCommonDepartments, inProgress: true },
      };
    case FETCH_COMMON_DEPARTMENT_SUCCESS:
      return {
        ...state,
        fetchCommonDepartments: {
          ...state.fetchCommonDepartments,
          success: true,
          inProgress: false,
        },
        commonDepartments: payload.departments,
      };
    case FETCH_COMMON_DEPARTMENT_FAILURE:
      return {
        ...state,
        fetchCommonDepartments: {
          ...state.fetchCommonDepartments,
          error: true,
          errorMessage: payload.error,
        },
      };

    default:
      return state;
  }
};

export default departmentReducer;
